import React from "react";
import { array, object, string } from "prop-types";
import { ClientSideOnly, ResponsiveImage } from "@quintype/components";

import "./author.m.css";
import { SvgIconHandler } from "../svg-icon-hadler";

const AuthorAvatar = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];
  let imageView = null;

  if (avatarURL) {
    imageView = (
      <ResponsiveImage styleName="author-img" slug={avatarURL} aspectRatio={[1, 1]} alt={name.substring(1)} />
    );
  } else if (authorAvatarUrl) {
    imageView = <img styleName="author-img" src={authorAvatarUrl} alt={name.substring(1)} />;
  } else {
    imageView = (
      <div styleName="default-author-img">
        <SvgIconHandler type="authoruser" />
      </div>
    );
  }

  return <ClientSideOnly>{imageView}</ClientSideOnly>;
};

AuthorAvatar.propTypes = {
  author: object
};

const Author = ({ authors }) => {
  return (
    <div styleName="authors-wrapper">
      {authors &&
        authors.map((author, index) => (
          <>
            <div key={index} styleName="author-wrapper">
              <div styleName="author-avatar">
                <AuthorAvatar author={author} />
              </div>
              <div styleName="author-name">
                <a href={`/author/${author.slug}`}>{author.name}</a>
              </div>
            </div>
          </>
          // <>
          //   {author["contributor-role"]?.name === "Byline Author" ? (
          //     <div key={index} styleName="author-wrapper">
          //       <div styleName="author-avatar">
          //         <AuthorAvatar author={author} />
          //       </div>
          //       <div styleName="author-name">
          //         <a href={`/author/${author.slug}`}>{author.name}</a>
          //       </div>
          //     </div>
          //   ) : (
          //     <div key={index} styleName="author-wrapper">
          //       <div styleName="author-avatar">
          //         <img
          //           styleName="author-img"
          //           src="https://images.prajavani.net/prajavani/2023-05/80c75a5b-5a90-4aba-95fc-0c3e506df9e0/prajavani_author.jpg"
          //           alt="prajavani_author"
          //         />
          //       </div>
          //       <div styleName="author-name">
          //         <p>ಪ್ರಜಾವಾಣಿ ವಾರ್ತೆ</p>
          //       </div>
          //     </div>
          //   )}
          // </>
        ))}
    </div>
  );
};

Author.propTypes = {
  authors: array
};

export default Author;
